import { useRef, useState } from "react";
import { createPortal } from "react-dom";

export function Tooltip({
  content,
  children,
  className,
  width = "w-max max-w-xs",
}: {
  content: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  width?: string;
}) {
  const ref = useRef<HTMLSpanElement>(null);
  const [pos, setPos] = useState<{ x: number; y: number } | null>(null);

  function show() {
    const r = ref.current?.getBoundingClientRect();
    if (r) setPos({ x: r.left, y: r.bottom + 6 });
  }

  return (
    <>
      <span
        ref={ref}
        onMouseEnter={show}
        onMouseLeave={() => setPos(null)}
        className={`inline-flex items-center gap-1 ${className ?? ""}`}
      >
        {children}
      </span>
      {pos &&
        createPortal(
          <div
            style={{ position: "fixed", left: pos.x, top: pos.y, zIndex: 9999 }}
            className={`pointer-events-none ${width} rounded-md bg-zinc-800 px-3 py-2 text-xs leading-snug text-white shadow-lg`}
          >
            {content}
          </div>,
          document.body,
        )}
    </>
  );
}
